import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, KeepAlive as _KeepAlive, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/textlogo.png'


const _withScopeId = n => (_pushScopeId("data-v-80cccf94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "desktop" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/icon/Search.png" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Search", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<a class=\"app\" data-v-80cccf94><img src=\"/icon/Meta.png\" data-v-80cccf94><span data-v-80cccf94>Wallet</span></a><a class=\"app\" data-v-80cccf94><img src=\"/icon/Covid.png\" data-v-80cccf94><span data-v-80cccf94>Covid</span></a><a class=\"app\" data-v-80cccf94><img src=\"/icon/Docs.png\" data-v-80cccf94><span data-v-80cccf94>Docs</span></a><a class=\"app\" href=\"mailto:hello@asearch.io\" data-v-80cccf94><img src=\"/icon/Mail.png\" data-v-80cccf94><span data-v-80cccf94>Mail-us</span></a><a class=\"app\" href=\"https://github.com/AR-HACKSON/\" target=\"_blank\" data-v-80cccf94><img src=\"/icon/Github.png\" data-v-80cccf94><span data-v-80cccf94>Github</span></a><a class=\"app\" href=\"https://medium.com/@kristiancy/web3-search-engine-in-the-future-5b5ad48e55d1\" target=\"_blank\" data-v-80cccf94><img src=\"/icon/Medium.png\" data-v-80cccf94><span data-v-80cccf94>Medium</span></a><a class=\"app\" href=\"https://twitter.com/Asearch_io\" target=\"_blank\" data-v-80cccf94><img src=\"/icon/Twitter.png\" data-v-80cccf94><span data-v-80cccf94>Twitter</span></a><a class=\"app\" href=\"https://discord.com\" target=\"_blank\" data-v-80cccf94><img src=\"/icon/Dis.png\" data-v-80cccf94><span data-v-80cccf94>Discord</span></a><img class=\"logo\" src=\"" + _imports_0 + "\" data-v-80cccf94>", 9)
const _hoisted_14 = { class: "as-taskbar" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/logo.png" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "minimized" }
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StartingUp = _resolveComponent("StartingUp")!
  const _component_Window = _resolveComponent("Window")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "starting" }, {
      default: _withCtx(() => [
        (_ctx.starting)
          ? (_openBlock(), _createBlock(_component_StartingUp, {
              key: 0,
              onStart: _ctx.start
            }, null, 8, ["onStart"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "app",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open('aSearch')))
      }, _hoisted_4),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", {
        class: "start",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.starting = true))
      }, _hoisted_16),
      _createElementVNode("div", _hoisted_17, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.minimized, (item, i) => {
          return (_openBlock(), _createElementBlock("span", {
            key: i,
            onClick: ($event: any) => (_ctx.reopen(item))
          }, _toDisplayString(item), 9, _hoisted_18))
        }), 128))
      ])
    ]),
    _createVNode(_Transition, { name: "window" }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_ctx.show)
            ? (_openBlock(), _createBlock(_component_Window, {
                key: 0,
                onClose: _ctx.close,
                onMinimize: _ctx.minimize
              }, null, 8, ["onClose", "onMinimize"]))
            : _createCommentVNode("", true)
        ], 1024))
      ]),
      _: 1
    })
  ]))
}